var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgLogoInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 94,
    viewBox: "0 0 96 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 94,
    rx: 47,
    fill: "#C3D9FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_2936_10447)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.5,
    cy: 74,
    rx: 12.5,
    ry: 6,
    fill: "#7E7D99",
    fillOpacity: 0.77
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2936_10447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4795 32.6902L48.6462 15.1902C48.4567 15.0667 48.2354 15.001 48.0092 15.001C47.783 15.001 47.5617 15.0667 47.3722 15.1902L20.5389 32.6902C20.2892 32.8633 20.1169 33.127 20.0586 33.4252C20.0002 33.7233 20.0606 34.0325 20.2267 34.2869C20.3928 34.5413 20.6515 34.7208 20.948 34.7874C21.2444 34.8539 21.5551 34.8022 21.814 34.6432L24.6665 32.7766V67.5001C24.6665 68.4283 25.0353 69.3186 25.6917 69.9749C26.348 70.6313 27.2383 71.0001 28.1665 71.0001H67.8414C68.7696 71.0001 69.6599 70.6313 70.3162 69.9749C70.9726 69.3186 71.3414 68.4283 71.3414 67.5001V32.7766C71.794 32.9924 74.3514 34.9512 74.8414 34.8334C75.0902 34.8285 75.3311 34.7447 75.5291 34.5939C75.7272 34.4432 75.8722 34.2334 75.9432 33.9949C76.0143 33.7564 76.0076 33.5014 75.9243 33.2669C75.8409 33.0324 75.6852 32.8304 75.4795 32.6902V32.6902Z",
    fill: "#4366BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4999 68.6663C29.5716 68.6663 28.6814 68.2975 28.025 67.6411C27.3686 66.9848 26.9999 66.0945 26.9999 65.1663V28.4688L20.5296 32.6898C20.3967 32.7713 20.2815 32.8788 20.1908 33.0056C20.1002 33.1325 20.0359 33.2762 20.0017 33.4284C19.9676 33.5805 19.9643 33.738 19.992 33.8914C20.0197 34.0449 20.0779 34.1912 20.1632 34.3218C20.2484 34.4523 20.359 34.5645 20.4883 34.6516C20.6177 34.7387 20.7631 34.799 20.9162 34.8289C21.0692 34.8588 21.2267 34.8578 21.3793 34.8258C21.5319 34.7938 21.6766 34.7316 21.8047 34.6428L24.6666 32.7761V67.4996C24.6666 68.4279 25.0353 69.3181 25.6917 69.9745C26.3481 70.6309 27.2383 70.9996 28.1666 70.9996H67.8414C68.5921 70.9971 69.3221 70.7528 69.9231 70.3029C70.5241 69.853 70.9642 69.2214 71.1781 68.5018C70.8536 68.606 70.5155 68.6614 70.1747 68.6663H30.4999Z",
    fill: "#2447A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0069 45.333H33.9999C33.6905 45.333 33.3938 45.4559 33.175 45.6747C32.9562 45.8935 32.8333 46.1903 32.8333 46.4997V70.9997H63.1666V46.4997C63.1666 46.1915 63.0447 45.8958 62.8274 45.6772C62.6101 45.4586 62.3151 45.3349 62.0069 45.333Z",
    fill: "#E8EBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8354 68.667H63.1735V71.0003H32.8354V68.667Z",
    fill: "#D0D6ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6725 48.833H43.3368C42.6925 48.833 42.1702 49.3553 42.1702 49.9997V59.333C42.1702 59.9773 42.6925 60.4997 43.3368 60.4997H52.6725C53.3168 60.4997 53.8392 59.9773 53.8392 59.333V49.9997C53.8392 49.3553 53.3168 48.833 52.6725 48.833Z",
    fill: "#FFB633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3332 58.1663V48.833C43.0238 48.833 42.727 48.9559 42.5082 49.1747C42.2894 49.3935 42.1665 49.6903 42.1665 49.9997V59.333C42.1665 59.6424 42.2894 59.9392 42.5082 60.158C42.727 60.3767 43.0238 60.4997 43.3332 60.4997H52.6665C52.9759 60.4997 53.2727 60.3767 53.4915 60.158C53.7103 59.9392 53.8332 59.6424 53.8332 59.333H44.4998C44.1904 59.333 43.8937 59.2101 43.6749 58.9913C43.4561 58.7725 43.3332 58.4758 43.3332 58.1663Z",
    fill: "#EBC176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8379 60.5H38.6689C38.0245 60.5 37.5022 61.0223 37.5022 61.6667V69.8333C37.5022 70.4777 38.0245 71 38.6689 71H46.8379C47.4822 71 48.0045 70.4777 48.0045 69.8333V61.6667C48.0045 61.0223 47.4822 60.5 46.8379 60.5Z",
    fill: "#FFB633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3403 60.5H49.1713C48.527 60.5 48.0046 61.0223 48.0046 61.6667V69.8333C48.0046 70.4777 48.527 71 49.1713 71H57.3403C57.9847 71 58.507 70.4777 58.507 69.8333V61.6667C58.507 61.0223 57.9847 60.5 57.3403 60.5Z",
    fill: "#FFB633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1667 68.6667V60.5C48.8572 60.5 48.5605 60.6229 48.3417 60.8417C48.1229 61.0605 48 61.3572 48 61.6667V69.8333C48 70.1428 48.1229 70.4395 48.3417 70.6583C48.5605 70.8771 48.8572 71 49.1667 71H57.3333C57.6428 71 57.9395 70.8771 58.1583 70.6583C58.3771 70.4395 58.5 70.1428 58.5 69.8333H50.3333C50.0239 69.8333 49.7272 69.7104 49.5084 69.4916C49.2896 69.2728 49.1667 68.9761 49.1667 68.6667Z",
    fill: "#EBC176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 68.6667V60.5C38.3572 60.5 38.0605 60.6229 37.8417 60.8417C37.6229 61.0605 37.5 61.3572 37.5 61.6667V69.8333C37.5 70.1428 37.6229 70.4395 37.8417 70.6583C38.0605 70.8771 38.3572 71 38.6667 71H46.8333C47.1428 71 47.4395 70.8771 47.6583 70.6583C47.8771 70.4395 48 70.1428 48 69.8333H39.8333C39.5239 69.8333 39.2272 69.7104 39.0084 69.4916C38.7896 69.2728 38.6667 68.9761 38.6667 68.6667Z",
    fill: "#EBC176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1724 39.4993H39.8332C39.5238 39.4993 39.227 39.3764 39.0082 39.1576C38.7894 38.9388 38.6665 38.6421 38.6665 38.3327C38.6665 38.0233 38.7894 37.7265 39.0082 37.5077C39.227 37.2889 39.5238 37.166 39.8332 37.166H56.1665C56.4759 37.166 56.7727 37.2889 56.9915 37.5077C57.2103 37.7265 57.3332 38.0233 57.3332 38.3327C57.3332 38.6421 57.2103 38.9388 56.9915 39.1576C56.7727 39.3764 56.4759 39.4993 56.1665 39.4993H56.1724Z",
    fill: "#E8EBF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1724 33.6663H39.8332C39.5238 33.6663 39.227 33.5434 39.0082 33.3246C38.7894 33.1058 38.6665 32.8091 38.6665 32.4997C38.6665 32.1903 38.7894 31.8935 39.0082 31.6747C39.227 31.4559 39.5238 31.333 39.8332 31.333H56.1665C56.4759 31.333 56.7727 31.4559 56.9915 31.6747C57.2103 31.8935 57.3332 32.1903 57.3332 32.4997C57.3332 32.8091 57.2103 33.1058 56.9915 33.3246C56.7727 33.5434 56.4759 33.6663 56.1665 33.6663H56.1724Z",
    fill: "#E8EBF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2936_10447",
    x: 21,
    y: 54,
    width: 53,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_2936_10447"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2936_10447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(20 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogoInventory);
export default __webpack_public_path__ + "static/media/ImgLogoInventory.32a6f0df9793a90a863aff2b712013a1.svg";
export { ForwardRef as ReactComponent };